(function($){
  $(document).on( 'ready', function(){

    if($('.livingdocs').children().first().hasClass('slider-on-home-page')) {
      $('.livingdocs').css('margin-top', 0);
    }

    if($(window).width()< 768){
      new Swiper('.ns-img-gallery:not(.slider-on-home-page)', {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: $('.swiper-slide').length > 1 ? { delay: 5000 } : false,
        loop: $('.swiper-slide').length > 1 ? true : false,
        // autoHeight: true,
        // calculateHeight:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init: setBackgroundImage,
        }
      });

      new Swiper('.slider-on-home-page', {
        slidesPerView: 1,
        spaceBetween: 0,
        // calculateHeight:true,
        // height: $(window).height() - $('.header').outerHeight(),
        autoplay: $('.swiper-slide').length > 1 ? { delay: 5000 } : false,
        loop: $('.swiper-slide').length > 1 ? true : false,
        pagination: {
          el: '.ns-img-gallery__pagination',
          clickable: true,
        },
        on: {
          init: setBackgroundImage,
        }
      });

    } else {
      new Swiper('.ns-img-gallery:not(.slider-on-home-page):not(.one-slide-per-screen)', {
        slidesPerView: 2,
        spaceBetween: 20,
        autoplay: $('.swiper-slide').length > 2 ? { delay: 5000 } : false,
        loop: $('.swiper-slide').length > 2 ? true : false,
        autoHeight: true,
        calculateHeight:true,
        pagination: {
          el: '.ns-img-gallery__pagination',
          clickable: true,
        },
        on: {
          init: setBackgroundImage,
        }
      });

      new Swiper('.slider-on-home-page, .one-slide-per-screen', {
        slidesPerView: 1,
        spaceBetween: 0,
        // calculateHeight:true,
        // height: $(window).height() - $('.header').outerHeight(),
        autoplay: $('.swiper-slide').length > 1 ? { delay: 5000 } : false,
        loop: $('.swiper-slide').length > 1 ? true : false,
        pagination: {
          el: '.ns-img-gallery__pagination',
          clickable: true,
        },
        on: {
          init: setBackgroundImage,
        }
      });
    }
  });

  // console.log($(window).height() - $('.header').outerHeight());

  function setBackgroundImage() {
    $('.swiper-container').each(function(){
      if($(this).hasClass('slider-on-home-page')){
        // console.log('home page');
        $('.swiper-slide').each(function(){
          // console.log($(this));
          if($(this).find('.ns-img--mobile').length){
            // console.log('has mobile image');
            var bg;
            if($(window).width() >= 768) {
              var bg = $(this).find('.ns-img__img--desktop').attr('data-src');
            } else {
              var bg = $(this).find('.ns-img__img--mobile').attr('data-src');
            }
            if(!!bg){
              $(this).find('.ns-img').css('background-image', 'url('+bg.replace('?width=1240', '')+')');
            }

          } else {
            // console.log('no mobile img');
            var bg = $(this).find('.ns-img__img--desktop').attr('data-src');
            // console.log(bg);

            if(!!bg){
              $(this).find('.ns-img').css('background-image', 'url('+bg.replace('?width=1240', '')+')');
            }
          }
        });
      } else {
        // console.log('not home page');
        removeLazyFromSliders();
      }
    });
  }

  function removeLazyFromSliders(){
    $('.swiper-slide img:not(.doc-image-empty)').each(function(){
      $(this).attr('src', $(this).attr('data-src')).removeClass('lazy');
      // console.log('remove lazy');
      // console.log($(this));
    });
  }

  $('.ns-img-gallery').each(function(){
    var slide = $(this).find('.swiper-slide');
    if(slide.length == 1) {
      $(this).find('.swiper-wrapper').addClass( "disabled" );
      $(this).find('.swiper-pagination').addClass( "disabled" );
    }
  });

  if($(window).width()>= 768){
    $('.ns-img-gallery:not(.slider-on-home-page):not(.one-slide-per-screen)').each(function(){
      var slide = $(this).find('.swiper-slide');
      if(slide.length == 2) {
        $(this).find('.swiper-wrapper').addClass( "disabled" );
        $(this).find('.swiper-pagination').addClass( "disabled" );
      }
    });
  }

})(jQuery);
